import {
    UserSubscriptionsDocument,
    useUncancelCurrentSubscriptionMutation,
} from '@lingoda/monolith-graphql';
import { useDispatch } from '@lingoda/hooks';
import { UserSubscriptionsFullDocument } from '../queries.monolith.generated';
import { fetchSubscriptions } from '../actions';

type UseUncancelSubscriptionOptions = Omit<
    NonNullable<Parameters<typeof useUncancelCurrentSubscriptionMutation>[0]>,
    'refetchQueries'
>;

export const useUncancelSubscription = (options: UseUncancelSubscriptionOptions = {}) => {
    const dispatch = useDispatch();

    const [uncancelMutation, { loading }] = useUncancelCurrentSubscriptionMutation({
        ...options,
        refetchQueries: [
            UserSubscriptionsDocument, // temporary until we get rid of the old types and queries
            UserSubscriptionsFullDocument,
        ],
        awaitRefetchQueries: true,
        onCompleted(data) {
            // Is used for updating redux store, until we get rid of it completely
            dispatch(fetchSubscriptions());
            options?.onCompleted?.(data);
        },
    });

    return [uncancelMutation, { loading }] as const;
};
